/**
 * Vessel-related models
 */

/**
 * Vessel DTO (Response)
 */
export interface VesselDto {
  id: string;
  customerId: string;
  vesselName: string;
  make: string;
  model: string;
  year: number;
  vesselType: string;
  length: number;
  beam: number;
  draft: number;
  height: number;
  weight: number;
  registrationNumber: string;
  hin: string;
  engineType?: string | null;
  engineHp?: number | null;
  insuranceId?: string | null;
  insuranceStatus?: string | null; // EXPIRED, VERIFIED, PENDING, NONE
  insurance?: import('./insurance.models').InsuranceDto | null; // Latest insurance object
  lease?: import('./lease.models').LeaseDto | null; // Most relevant lease/contract (prefers Active, then most recent)
  photoUrl?: string | null;
  notes?: string | null;
  contactFirstName?: string | null;
  contactLastName?: string | null;
  contactEmail?: string | null;
  slipId?: string | null;
  dryDockLocationId?: string | null;
  permanentLocationName?: string | null;
  temporaryLocationId?: string | null;
  temporaryLocationName?: string | null;
  vesselStatus?: string;
  createdAt: string;
  updatedAt: string;
  /** Hidden from active fleet when true (staff archive). */
  isArchived?: boolean;
  archivedAt?: string | null;
}

/**
 * Create vessel request
 */
export interface CreateVesselRequest {
  customerId: string;
  vesselName: string;
  make?: string | null;
  model?: string | null;
  year?: number | null;
  length?: number | null;
  beam?: number | null;
  draft?: number | null;
  registrationNumber?: string | null;
  engineType?: string | null;
  engineHp?: number | null;
  photoUrl?: string | null;
  notes?: string | null;
  contactFirstName?: string | null;
  contactLastName?: string | null;
  contactEmail?: string | null;
  slipId?: string | null;
  dryDockLocationId?: string | null;
}

